module.exports = __webpack_public_path__ + "img/160.7201e2d9.jpg";